export function addLeadingZeros(num, size = 2) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
}

export function formatTime(time) {
    return addLeadingZeros(Math.floor(time / 60)) + ':' + addLeadingZeros(time % 60);
}